<template>
  <div class="category-list">
    <el-row class="">
      <el-collapse accordion v-model="activeNames" v-if="items.length ==0 || isEditing">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="title">
              <div @click.stop class="opt-area">
                <el-button type="success" size="medium"
                           @click="showNewPanel">{{ activeNames.length > 0 ? '收起' : '新增裂变活动' }}
                </el-button>
              </div>
            </div>
          </template>
          <el-form :label-position="labelPosition" ref="item-form" :model="item" :rules="rules"
                   label-width="200px">
            <el-form-item label="活动名称:" prop="name">
              <el-col :span="12">
                <el-input :span="6" placeholder="请输入活动名称"
                          v-model="item.name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="是否开启" prop="openFreeOrder">
              <el-col :span="12">
                <el-switch v-model="item.openFreeOrder"></el-switch>
              </el-col>
            </el-form-item>
            <!--<el-form-item label="积分别名:" prop="aliasName">
                <el-col :span="12">
                    <el-input :span="6" placeholder="请输入积分别名"
                              v-model="aliasName"></el-input>
                </el-col>
                <el-col :span="24">
                    <el-alert
                            close-text="知道了"
                            type="warning">
                        <p class="alter-text">默认名称是积分，也可以自己设置别名，比如金币，元宝等等</p>
                    </el-alert>
                </el-col>
            </el-form-item>-->
            <el-form-item label="邀请1个下级所得积分:" prop="point">
              <el-col :span="12">
                <el-input :span="6" placeholder="请输入邀请1位好友所得积分"
                          v-model.number="item.point" @input="changeInput"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="下级完成首单所得积分:" prop="parentPoint">
              <el-col :span="12">
                <el-input :span="6" placeholder="请输入下级完成首单上级所得积分"
                          v-model.number="item.parentPoint" @input="changeInput"></el-input>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="warning">
                  <p class="alter-text">填0或者留空，表示下级完成首单，不给上级奖励</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="活动时间" prop="activityTime">
              <el-col :span="12">
                <el-date-picker
                    v-model="item.activityTime"
                    class="form-item"
                    type="datetimerange"
                    @input="daterangeChange"
                    :picker-options="pickerOptions"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    clearable
                    align="right">
                </el-date-picker>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="warning">
                  <p class="alter-text">如何不选择，表示活动长期有效</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <!--<el-form-item label="banner地址:" prop="freeOrderBanner">
                <el-col :span="12">
                    <el-input :span="6" placeholder="请输入banner图片地址" type="textarea" autosize
                              v-model="item.freeOrderBanner"></el-input>
                </el-col>
                <el-col :span="24">
                    <el-alert
                            close-text="知道了"
                            type="warning">
                        <p class="alter-text">banner图片活动期间会显示在首页，点击进入活动页面</p>
                    </el-alert>
                </el-col>
            </el-form-item>-->
            <el-form-item label="活动规则:">
              <template v-if="item.rules&&item.rules.length>0">
                <el-col :span="24" class="rules"
                        v-for="(rule,indexRule) in item.rules">
                  <el-col :span="12">
                    <el-input
                        type="textarea"
                        autosize
                        v-model="rule.text" @input="changeInput">

                    </el-input>
                  </el-col>
                  <el-col :span="4">
                    <el-button class="opt" type="primary" size="small"
                               @click="addTextRule(indexRule)" style="margin-left: 10px">加规则
                    </el-button>
                    <el-button class="opt" type="danger" size="small"
                               @click="deleteTextRule(indexRule)">
                      删文案
                    </el-button>
                  </el-col>
                </el-col>
              </template>
              <template v-else>
                <el-col :span="12">
                  <el-button class="" type="primary" size="small" @click="initTextRules()">加规则
                  </el-button>
                </el-col>
              </template>
            </el-form-item>


            <el-form-item>
              <el-button type="primary" size="medium" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>

        </el-collapse-item>
      </el-collapse>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
            :data="items"
            border>
          <el-table-column
              label="名称"
              prop="name">
          </el-table-column>
          <el-table-column
              label="是否开启"
              width="250">
            <template slot-scope="scope">
              {{ scope.row.openFreeOrder ? "已开启" : "未开启" }}
            </template>
          </el-table-column>
          <el-table-column
              label="活动图片"
              width="250">
            <template slot-scope="scope">
              <div class="cell-item-img">
                <el-popover
                    placement="right"
                    trigger="hover"
                    width="300"
                    :title="scope.row.name"
                    :ref="'popover-' + scope.row.id">
                  <img :src="scope.row.imgUrl" v-show="scope.row.imgUrl">
                  <img slot="reference" :src="scope.row.imgUrl"
                       v-show="scope.row.imgUrl"
                       class="media-image"/>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="展示模式"
              prop="upcLayout">
            <template slot-scope="scope">
              {{ scope.row.upcLayout == 'bigPic' ? '大图' : '小图' }}
            </template>
          </el-table-column>
          <!--<el-table-column
                  label="积分别名"
                  prop="aliasName"
                  width="150">
          </el-table-column>-->
          <el-table-column
              label="所得积分"
              prop="point"
              width="150">
          </el-table-column>
          <el-table-column
              label="下级首单积分"
              prop="parentPoint"
              width="150">
          </el-table-column>
          <el-table-column
              label="描述"
              prop="introduce"
              width="200">
          </el-table-column>
          <el-table-column
              label="开始时间"
              prop="startTime"
              width="150">
          </el-table-column>
          <el-table-column
              label="结束时间"
              prop="endTime"
              width="150">
          </el-table-column>
          <el-table-column
              label="操作"
              fixed="right"
              width="230">
            <template slot-scope="scope">
              <div class="opt-item">
                <el-button @click="editRow(scope.row)" size="mini" class="" type="success">编辑
                </el-button>
              </div>
              <div class="opt-item">
                <el-button @click="copyPagePath(scope.row)"
                           v-clipboard:copy="'/pages/user-products/user-products?themeId='+scope.row.id+'&themeType=upc'"
                           v-clipboard:success="onCopy"
                           v-clipboard:error="onError"
                           size="mini"
                           type="success">复制页面路径
                </el-button>
              </div>

            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog
        title="海报生成成功"
        :visible.sync="dialogVisible"
        width="30%">
      <el-alert
          title="温馨提示"
          type="success"
          close-text="知道了"
          show-icon>
        <p>鼠标右键点击，保存图片</p>
        <p>微信扫码打开专题，转发好友</p>
      </el-alert>
      <img :src="shareImgUrl" class="shareimg" v-if="shareImgUrl">
      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
             </span>
    </el-dialog>
  </div>
</template>
<script>
import {userProductCategoryApi} from "../../common/userProductCategoryApi";

export default {
  data() {
    return {
      activeNames: [],
      isEditing: false,
      item: {
        upcType: 'INVITE',
        openFreeOrder: false,
        point: '',
        parentPoint: '',
        rules: [],
        activityTime: ['开始时间', '结束时间']
      },
      maxTextRules: 5,
      upcLayout: 'smallPic',
      upcType: 'INVITE',
      openFreeOrder: false,
      onlyNewUser: false,
      page: 1,
      pageSize: 10,
      totalCount: 0,
      items: [],
      labelPosition: 'left',
      dialogVisible: false,
      shareImgUrl: null,
      pickerOptions: {
        shortcuts: [
          {
            text: '近一周',
            onClick(picker) {
              const start = new Date(new Date(new Date().getTime()).setHours(0, 0, 0, 0));
              const end = new Date(new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0))
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近半月',
            onClick(picker) {
              const start = new Date(new Date(new Date().getTime()).setHours(0, 0, 0, 0));
              const end = new Date(new Date(new Date().getTime() + 15 * (24 * 60 * 60 * 1000)).setHours(0, 0, 0, 0))
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '1月',
            onClick(picker) {
              const start = new Date(new Date(new Date().getTime()).setHours(0, 0, 0, 0));
              const end = new Date(new Date(new Date().getTime() + 30 * (24 * 60 * 60 * 1000)).setHours(0, 0, 0, 0))
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      rules: {
        introduce: [
          {required: false, message: '请输入专题简介', trigger: 'blur'},
          {min: 3, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur'}
        ],
        point: [
          {required: true, message: '请输入所需积分', trigger: 'blur'},
        ],
        parentPoint: [
          {required: false, message: '请输入首单积分', trigger: 'blur'},
        ],
        activityTime: [
          {required: false, message: '请选择活动时间', trigger: 'blur'},
        ],
      }
    }

  },
  created() {
    var that = this
    userProductCategoryApi.getUserProductCategories.call(that, {
      page: that.page,
      pageSize: that.pageSize,
      upcType: 'INVITE'
    }, function (res) {
      if (res.result.items) {
        that.items = res.result.items;
        for (let i = 0; i < that.items.length; i++) {
          let item = that.items[i];
          if (item.config) {
            var config = JSON.parse(item.config);
            if (config.point) {
              item.point = config.point;
            }
            if (config.parentPoint) {
              item.parentPoint = config.parentPoint;
            }
            item.aliasName = config.aliasName
          }
        }
      }

      if (res.result.totalCount) {
        that.totalCount = res.result.totalCount
      }

    })
  },
  methods: {
    daterangeChange(e) {
      let _this = this
      _this.$nextTick(() => {
        _this.$forceUpdate()
      })
    },
    changeInput() {
      this.$forceUpdate()
    },
    showNewPanel() {
      this.item = {upcType: 'INVITE', upcLayout: 'smallPic'}
      if (this.activeNames.length > 0) {
        this.activeNames = []
      } else {
        this.activeNames = ["1"]
      }
      this.isEditing = false
    },
    onCopy() {
      this.successMsg("复制成功");
    },
    onError() {
      this.failMsg("复制失败")
    },

    editRow(item) {
      this.isEditing = true
      if (typeof (item.upcType) == "undefined") {
        this.upcType = 'INVITE'
      } else {
        this.upcType = item.upcType
      }
      if (typeof (item.upcLayout) == "undefined") {
        this.upcLayout = 'smallPic'
      } else {
        this.upcLayout = item.upcLayout
      }
      if (item.config) {
        var config = JSON.parse(item.config);
        item.point = config.point?config.point:0,
        item.parentPoint = config.parentPoint?config.parentPoint:""
        item.rules = config.rules
      } else {
        item.point = 0
        item.parentPoint = ""
        item.rules = []
      }

      if (item.startTime && item.endTime) {
        item.activityTime = []
        item.activityTime.push(item.startTime)
        item.activityTime.push(item.endTime)
      } else {
        item.activityTime = ['开始时间', '结束时间']
      }
      this.item = item;
      this.activeNames = ["1"]
      this.$nextTick(() => this.$refs['item-form'].clearValidate())
      this.$forceUpdate()
    },
    shareImg(item) {
      var that = this
      userProductCategoryApi.getUserProductCategoryShareImg.call(that, {id: item.id}, function (res) {
        if (res.result.shareImg) {
          that.dialogVisible = true;
          that.shareImgUrl = res.result.shareImg
        }
      })
    },
    handleCurrentChange() {
      var that = this
      var data = {}
      data.page = that.page;
      data.pageSize = that.pageSize
      userProductCategoryApi.getUserProductCategories.call(that, data, function (res) {
        if (res.result.items) {
          that.items = res.result.items
        }
        if (res.result.totalCount) {
          that.totalCount = res.result.totalCount
        }

      })
    },
    initTextRules() {
      this.item.rules = [{text: ""}]
      this.$forceUpdate()
    },
    addTextRule(index) {
      if (this.item.rules.length >= this.maxTextRules) {
        this.failMsg("最大支持" + this.maxTextRules + "个规则");
        return;
      }
      this.item.rules.splice(index + 1, 0, {
        text: ''
      });
      this.$forceUpdate()
    },
    deleteTextRule(index) {
      this.item.rules.splice(index, 1)
      this.$forceUpdate()
    },
    onSubmit() {
      var that = this;
      this.$refs['item-form'].validate((valid) => {
        if (valid) {
          that.item.upcLayout = that.upcLayout
          that.item.upcType = that.upcType
          var config = {
            aliasName: that.item.aliasName,
            point: that.item.point,
            parentPoint: that.item.parentPoint,
            rules: that.item.rules

          }
          if (that.item.activityTime && that.item.activityTime[0] != '开始时间') {
            that.item.startTime = that.item.activityTime[0]
            that.item.endTime = that.item.activityTime[1]
          }
          that.item.config = JSON.stringify(config)
          userProductCategoryApi.createOrUpdateCategory.call(that, that.item, function (res) {
            if (res.result.item && !that.item.id) {
              that.items.push(res.result.item)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    }
  }
}


</script>
<style lang="scss">

.media-image {
  width: 80px;
  vertical-align: middle;
}

.shareimg {
  width: 100%;
}

.opt-item {
  margin-bottom: 10px;
}

</style>